import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { QueryAliases } from '../../../types/QueryAliases';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

interface UpdateMobileAppVersion {
  version: string;
}

const useUpdateMobileAppVersion = () => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();
  const { showErrorToast, showSuccessToast } = useToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    ({ id, data }: { id: string; data: UpdateMobileAppVersion }) =>
      axiosInstance.patch(api.endpoints.UPDATE_MOBILE_APP_VERSION(id), { ...data }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QueryAliases.MOBILE_APP_VERSION]);
        showSuccessToast(t('successMessages.mobileAppVersionUpdated'));
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.updateMobileAppVersionFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { updateMobileAppVersion: mutateAsync, isLoading };
};

export default useUpdateMobileAppVersion;
